module.exports = __webpack_public_path__ + "static/media/agroart.7559d40a.png";